import { render, staticRenderFns } from "./brokerzy-z-akcjami-ulamkowymi.md?vue&type=template&id=04b5e110&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports